import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import MessageUserView from "./messages.user.view";
import MessageTutorView from "./messages.admin.view";
import MessageCenterMasterView from "./messages.centermaster.view";
import "./messages.scss";

const Messages = () =>{
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);


    return (userType==='STUDENT'?<MessageUserView/>:
    userType === "COUNSELOR" ||userType === "TUTOR" ?  <MessageTutorView/> : <MessageCenterMasterView/>)
}

export default Messages;
